import {
  faBus,
  faShip,
  faSubway,
  faTrain,
  faTrainTram,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Line, LineGroup } from "../types/line";

export function getLineIcon(line: LineGroup | Line): IconDefinition {
  const lineGroup: LineGroup =
    typeof line === "string" ? line : getLineGroup(line);

  switch (lineGroup) {
    case "Tunnelbanans blå linje":
    case "Tunnelbanans röda linje":
    case "Tunnelbanans gröna linje":
      return faSubway;
    case "Spårväg City":
    case "Nockebybanan":
    case "Lidingöbanan":
    case "Tvärbanan":
      return faTrainTram;
    case "Saltsjöbanan":
    case "Roslagsbanan":
    case "Pendeltåg":
      return faTrain;
    case "Blåbuss":
    case "Rödbus":
    case "Närtrafiken":
    case "Ersättningsbuss":
      return faBus;
    case "Pendelbåt":
    case "Lisen/Lotten":
    case "Fjäderholmslinjen":
      return faShip;
    default:
      return faBus;
  }
}

export function getLineColor(line: LineGroup | Line): string {
  const lineGroup: LineGroup =
    typeof line === "string" ? line : getLineGroup(line);

  switch (lineGroup) {
    case "Tunnelbanans blå linje":
    case "Nockebybanan":
    case "Blåbuss":
    case "Pendelbåt":
    case "Lisen/Lotten":
    case "Fjäderholmslinjen":
      return "bg-blue-500";
    case "Tunnelbanans röda linje":
    case "Rödbus":
    case "Närtrafiken":
    case "Ersättningsbuss":
      return "bg-red-500";
    case "Tunnelbanans gröna linje":
      return "bg-green-500";
    case "Spårväg City":
      return "bg-gray-500";
    case "Lidingöbanan":
      return "bg-brown-500";
    case "Tvärbanan":
      return "bg-orange-500";
    case "Pendeltåg":
      return "bg-pink-500";
    case "Saltsjöbanan":
      return "bg-turquoise-500";
    case "Roslagsbanan":
      return "bg-purple-500";
    default:
      return "bg-blue-500";
  }
}

export function LineIcon({ line }: { line: Line }) {
  let lineGroup: LineGroup;
  if (line.group_of_lines) {
    lineGroup = line.group_of_lines;
  }
  if (!line.group_of_lines && line.transport_mode === "BUS") {
    lineGroup = "Rödbus";
  } else {
    lineGroup = "Annat";
  }

  const lineIcon = getLineIcon(lineGroup);
  const lineColor = getLineColor(lineGroup);

  return (
    <div className={lineColor}>
      <FontAwesomeIcon color="white" icon={lineIcon} />
    </div>
  );
}

function getLineGroup(line: Line): LineGroup {
  if (line.group_of_lines) {
    return line.group_of_lines;
  }
  if (!line.group_of_lines && line.transport_mode === "BUS") {
    return "Rödbus";
  } else {
    return "Annat";
  }
}
